import { PageStore } from 'bernie-plugin-mobx';

export enum PageId {
  CSR = 'page.Car-Search,C,20',
  CIS = 'page.Cars.Infosite.Information,C,30',
  CDR = 'page.Car-Search.dropOff,C,20',
  RNR = 'page.Car.RNR,C,20',
  CSR_LOADING_WEB = 'page.PWA.Car-Search,C,20',
  CSR_LOADING_APP = 'app.PWA.Car-Search,C,20',
  MULTI_ITEM_FHC_CSR = 'page.Package.FHC.Car-Search,P,20',
  MULTI_ITEM_FC_CSR = 'page.Package.FC.Car-Search,P,20',
  MULTI_ITEM_HC_CSR = 'page.Package.HC.Car-Search,P,20'
}

export enum PageURL {
  CSR = '/carsearch/:multiitem?',
  CIS = '/carsearch/details',
  CDR = '/carsearch/dropoff',
  RNR = '/carsearch/rulesAndRestrictions'
}

interface PageIdentity {
  pageId: string;
  lineOfBusiness: string;
  funnelLocation: string;
}

export const getPageIdentity = (page: PageStore): PageIdentity => {
  return page && page.pageId && getPageIdentityFromId(page.pageId);
};

export const getPageIdentityFromId = (pageId: string): PageIdentity => {
  const identifiers = pageId.split(',').map(identifier => identifier.trim());

  return {
    pageId         : identifiers[0],
    lineOfBusiness : identifiers[1],
    funnelLocation : identifiers[2]
  };
};

export const getMultiItemPageId = (packageType: string): PageId => {
  switch (packageType) {
  case 'hc':
    return PageId.MULTI_ITEM_HC_CSR;
  case 'fhc':
    return PageId.MULTI_ITEM_FHC_CSR;
  default:
    return PageId.MULTI_ITEM_FC_CSR;
  }
};
